import{createContext as r,useContext as e}from"react";const o=r(void 0);function t(){const r=e(o);if(!r)throw new Error("useMediaMasks must be used within a MediaMasksProvider");return r}export{o as MediaMasksContext,t as useMediaMasks};
